export function exportOut(searchList, pathName, xlsName) {
  /**
   * @searchList params对象
   * @pathName 请求路径
   * @xlxName 导出文件名字 fileName='模板'
   */
  // 获取时间，这一步是在下载时文件名带下载日期，例如：用户信息2020-04-27.xls,如无需要可以去掉
  let d = new Date();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let time =
    d.getFullYear() +
    "-" +
    (String(month).length > 1 ? month : "0" + month) +
    "-" +
    (String(day).length > 1 ? day : "0" + day);
  // 地址
  let baseURL = process.env.VUE_APP_URL;
  // http://admin.test.1-trip.com

  // const PATH = {
  //   userList：'vue/export/userList', // 后台接口地址
  // }
  // 参数
  let params = "?";
  for (let key in searchList) {
    //?billNo=item.billNo
    params = params + key + "=" + searchList[key] + "&";
  }

  function createObjectURL(object) {
    return window.URL
      ? window.URL.createObjectURL(object)
      : window.webkitURL.createObjectURL(object);
  }
  var xhr = new XMLHttpRequest();
  var formData = new FormData();
  xhr.open("get", baseURL + pathName + params); // url填写后台的接口地址，如果是post，在formData append参数
  xhr.setRequestHeader("Authorization", localStorage.getItem("token"));
  xhr.responseType = "blob";
  xhr.onload = function(e) {
    if (this.status === 200) {
      var blob = this.response;
      // xls文件名称
      var filename = `${xlsName}${time}.xls`;
      // var filename = `${xlsName}.xls`;
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var a = document.createElement("a");
        var url = createObjectURL(blob);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }
  };
  xhr.send(formData);
}
